import apiClient from './client';

export interface ActivityItem {
  id: number;
  bus_content_id: number;
  item_parent_id: number;
  item_level: number;
  item_title: string;
  item_title_en: string;
  item_description: string;
  item_description_en: string | null;
  item_content_type: 1 | 2; // 1: 图片, 2: 视频
  item_content_url: string;
  item_background_url: string | null;
  item_h5_content_url: string;
  item_h5_background_url: string;
  item_h5_overlap_url: string | null;
  item_order: number;
  data_state: number;
  created_at: string;
  update_at: string;
  children: ActivityItem[];
}

export interface ActivityData {
  id: number;
  title: string;
  desc: string;
  header: string;
  poster: string;
  cover: string | null;
  trailer: string;
  info: any[];
  pictures: string[];
  pictures_title: string;
  items: ActivityItem[];
}

export interface ApiResponse {
  code: number;
  message: string;
  data: ActivityData;
}

export const getActivityContent = async (id: number = 40, lang: string = 'zh'): Promise<ApiResponse> => {
  const response = await apiClient.get(`/v1/business/content/${id}?lang=${lang}`);
  return response.data;
};
